import React from 'react';
import List from '../components/list';
import Services from '../components/services';
import bannerImage from '../images/shutterstock_1030638148.jpg';
import puzzleLogo from '../images/puzzle_logo.svg';
import Banner from '../components/banner';

const ServicesInCooperation = props =>
  (<main>
    <Banner
      title="Dienstleistungen in Kooperation"
      image={bannerImage}
    />
    <List
      text={
        <div>
          <ul>
            <li>Das klassische Leistungsspektrum der Wirtschaftsprüfung können wir mit unserem Kooperationspartnern aus dem ETL Netzwerk abdecken.</li>
            <li>Für juristische Fragen (insbesondere Gesellschaftsrecht, Familien- und Erbrecht, Arbeitsrecht) unterhalten wir Kontakte zu verschiedenen Anwaltskanzleien und Notaren.</li>
          </ul>
          <br />
          <p>Für weitergehende Fragen können Sie uns gerne ansprechen.</p>
        </div>
      }
      icon={puzzleLogo}
    />
    <Services
      taxAdvice={true}
      businessAdvice={true}
      servicesInCooperation={false}
      accounting={true}
      businessValuation={true}
    />
  </main>);

export default ServicesInCooperation;



// WEBPACK FOOTER //
// ./src/pages/dienstleistungen-in-kooperation.js